"use client";

import { c as _c } from "react/compiler-runtime";
import * as Sentry from "@sentry/nextjs";
import Image from "next/image";
import { useEffect } from "react";
import InternalErrorImage from "../../public/assets/internal-error.svg";
export default function AppError(t0) {
  const $ = _c(11);
  const {
    error,
    reset
  } = t0;
  let t1;
  let t2;
  if ($[0] !== error) {
    t1 = () => {
      Sentry.captureException(error);
    };
    t2 = [error];
    $[0] = error;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span aria-hidden="true" className="pointer-events-none absolute top-0 right-0 h-full w-[max(0px,calc((100vw-111.71875dvh)/2))] bg-[#B3DADC]" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h1 className="lg:text-4xl text-2xl font-alt font-semibold text-gray-900">Algo deu errado</h1>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-col gap-3 text-gray-600"><span className="md:whitespace-nowrap leading-tight"><p>Não foi possível carregar esta página.</p><p>O problema foi registrado e estamos verificando.</p></span><p>Tente novamente em instantes.</p></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== reset) {
    t6 = <div className="space-y-6 lg:p-0 lg:pr-40 lg:bg-transparent lg:rounded-none bg-white rounded-2xl p-6 lg:mx-0 mx-4">{t4}{t5}<button type="button" onClick={reset} className="sm:w-fit w-full text-primary-500 border border-primary-200 rounded-md px-5 py-1 cursor-pointer hover:bg-primary-100 transition-colors mt-4">Tentar novamente</button></div>;
    $[6] = reset;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="lg:w-full"><Image src={InternalErrorImage} alt="Homens trabalhando" priority={true} width={520} height={180} className="h-[180] object-contain lg:w-[520] lg:h-[260] lg:pr-20" /></div>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6) {
    t8 = <main className="relative h-dvh w-full overflow-hidden bg-white before:absolute before:inset-0 before:bg-[url('/assets/wave.png')] before:bg-size-[auto_100%] before:bg-center before:bg-no-repeat before:content-['']">{t3}<section className="relative z-10 h-full flex items-center justify-center lg:pl-16 max-w-8xl mx-auto flex-col-reverse lg:gap-0 lg:flex-row gap-30">{t6}{t7}</section></main>;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
}